export default {
  datePickerLong: "DD-MM-YY, HH:mm:ss",
  datePickerShort: "DD-MM-YY",
  tableDateLong: "DD-MM-YY, HH:mm:ss",
  tableDateMedium: "DD-MM-YY, HH:mm",
  tableDateShort: "DD-MM-YY",
};
